export const FORMAT = "YYYY/MM/DD";
export const TIMEJAPAN = "Asia/Tokyo";
export const FORMATJP = "YYYY/MM/DD (ddd)";
export const FORMAT_FOR_SET_TIMEZONE = "dd MM DD YYYY HH:mm:ss [GMT]Z"
